var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 30,
    viewBox: "0 0 34 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.25 7.06333V6.50384L29.8332 6.8771L16.7854 18.5622L3.49873 6.8392L3.08333 6.47269V7.02667V26.6667V26.9167H3.33333H30H30.25V26.6667V7.06333ZM4.185 3.08333H3.52383L4.01959 3.52079L16.6029 14.6241L16.7695 14.7711L16.9351 14.6229L29.3368 3.51959L29.824 3.08333H29.17H4.185ZM1.66667 0.25H31.6667C32.0424 0.25 32.4027 0.399256 32.6684 0.664932C32.9341 0.930608 33.0833 1.29094 33.0833 1.66667V28.3333C33.0833 28.7091 32.9341 29.0694 32.6684 29.3351C32.4027 29.6007 32.0424 29.75 31.6667 29.75H1.66667C1.29094 29.75 0.930608 29.6007 0.664932 29.3351C0.399256 29.0694 0.25 28.7091 0.25 28.3333V1.66667C0.25 1.29094 0.399255 0.930608 0.664932 0.664932C0.930609 0.399255 1.29094 0.25 1.66667 0.25Z",
    fill: "#E87400",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMail);
export default __webpack_public_path__ + "static/media/ico-mail.a433abd631bcd489be6df2625e66e1f9.svg";
export { ForwardRef as ReactComponent };